module.exports = __webpack_public_path__ + "static/media/23.c6a88536.jpg";